














import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class AddHospitalDialog extends Vue {
  @Prop()
  private projectId: any;
  @Prop()
  private visible: any;
  private hospital: any = {};
  private visibleChange() {
    this.$emit("update:visible", this.visible);
  }
  private get ifVisible() {
    return this.visible ? this.visible : false;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 确定添加患者并进入采集页面
   */
  private addHospital() {
    this.hospital.project_id = this.projectId;
    const params: any = this.hospital;
    axios.post("api/project/prohospital", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("加入成功");
        this.$emit("finish", data.data);
      });
    });
  }
}
